import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const DeleteButton = styled(({ ...props }: any) => <Button {...props} />)(
    ({ theme, label }) => ({
        color: `${theme.palette.error[600]}`,
    })
);

export default DeleteButton;
